import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { Card } from './ui/card';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SubscriptionGuard = ({ children }) => {
  const navigate = useNavigate();
  const { playerName } = useGame();
  const [checking, setChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    checkSubscription();
  }, [playerName]);

  const checkSubscription = async () => {
    if (!playerName) {
      navigate('/');
      return;
    }

    try {
      const response = await axios.get(`${API}/player/${playerName}/subscription`);
      
      if (response.data.subscription_status === 'active') {
        setHasAccess(true);
      } else {
        // No active subscription, redirect to payment
        navigate('/payment');
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      // If player doesn't exist or error, redirect to payment
      navigate('/payment');
    } finally {
      setChecking(false);
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{
        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)'
      }}>
        <Card className="p-12 bg-white/95 backdrop-blur-sm shadow-2xl text-center" style={{ borderRadius: '32px' }}>
          <Loader2 className="w-16 h-16 mx-auto mb-4 text-red-500 animate-spin" />
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Verifying Subscription...</h2>
          <p className="text-gray-600">Please wait</p>
        </Card>
      </div>
    );
  }

  return hasAccess ? children : null;
};

export default SubscriptionGuard;
